module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addPhone":"Add Phone","phones":"Phones"},"fr":{"addPhone":"Ajouter un téléphone","phones":"Téléphones"}}')
  delete Component.options._Ctor
}
